import {RouteDescriptor} from "../../RouteDescriptor";
import {Route} from "../../Route";
import {Role} from "../../../roles/Role";
import {EventCalendarPage} from "../../../../../pages/Lk/OperatorsOnly/EventCalendar/EventCalendarPage";
import {PageGroups} from "../../pageGroups";
import {defineMessage} from "react-intl";

const EventCalendarRouteTitleMessage = defineMessage({
  id: "eventCalendarRoute.title",
  defaultMessage: "Event Calendar",
})

export const eventCalendar: RouteDescriptor<Route.eventCalendar> = {
  route: Route.eventCalendar,
  render: EventCalendarPage,
  title: EventCalendarRouteTitleMessage,
  path: '/lk/event-calendar',
  allowRoles: [
    Role.freighterAdmin,
    Role.freighterServiceManager,
    Role.freighterClientManager,
    Role.admin,
  ],
  redirectToHomeRoles: [
  ],
  showInSidebar: true,
}

